import styled from 'styled-components';

const Container = styled.img`
  margin-right: 10px;
  width: 34px;
  object-fit: cover;
`;

export default Container;
